import e from "./ghl-ui.es723.js";
const n = {
  name: "en-US",
  locale: e
}, a = n;
export {
  a as default
};
